"use client";
import { useEffect, useRef } from "react";
import { browserTracking } from "./browser-tracking";
import { publicPage } from "./policy";
import { entityMatchesPage } from "./view-coordinator";

export function useEntityView(entity: {
  type: "product" | "content";
  id?: string | null;
  url?: string | null;
  open: boolean;
}) {
  const owner = useRef<object>({});
  const url = useRef(entity.url);
  url.current = entity.url;
  useEffect(() => {
    if (
      !entity.open ||
      !entity.id ||
      !url.current ||
      !publicPage(window.location.pathname)
    )
      return;
    if (entityMatchesPage(url.current, window.location.href)) return;
    return browserTracking().openEntity(
      owner.current,
      `${entity.type}:${entity.id}`,
      url.current,
    );
  }, [entity.open, entity.id, entity.type]);
}

export function EntityView({
  type,
  id,
  url,
  open,
}: {
  type: "product" | "content";
  id?: string | null;
  url?: string | null;
  open: boolean;
}) {
  useEntityView({ type, id, url, open });
  return null;
}
